import React, { useContext } from 'react';
import OptionsWrapper from './options-wrapper';
import CustomUniversalSelect from '../../../_utils/custom-universal-select';
import { SummaryDropdownContext } from './index';

export default function DropdownOptions({
  handleFinishChange,
  handleDeliveryChange,
}) {
  const {
    finishSelectorOptions,
    selectedFinishOption,
    selectedDeliveryOption,
    deliverySelectorOptions,
  } = useContext(SummaryDropdownContext);

  return (
    <div className="print-order__dropdown">
      <OptionsWrapper className="print-finish-selector" finishWrapper>
        <CustomUniversalSelect
          hideCheckBox
          solidArrowIcon
          id="print-finish-selector"
          value={selectedFinishOption.key || ''}
          options={finishSelectorOptions}
          ariaLabel="Select Finish"
          onChange={value => handleFinishChange(value)}
        />
      </OptionsWrapper>
      <OptionsWrapper className="delivery-selector">
        <CustomUniversalSelect
          hideCheckBox
          solidArrowIcon
          id="delivery-selector"
          value={selectedDeliveryOption.key || ''}
          options={deliverySelectorOptions}
          ariaLabel="Select Delivery Option"
          onChange={value => handleDeliveryChange(value)}
        />
      </OptionsWrapper>
    </div>
  );
}
